const zoneLocalStorageId = () => {
  return Number(localStorage.getItem("zone_id"));
};
export default zoneLocalStorageId;
